import { useRouterState } from '@tanstack/react-router';

/**
 * The replenishment page renders at two portal routes — Outgoing Purchase
 * Orders (`/procurement/replenishment`) and Outgoing Transfer Orders
 * (`/procurement/internal-transfers`). Shared components use this to keep their
 * in-page navigations on the current route instead of bouncing to the POs page.
 */
export function useReplenishmentBasePath():
  '/procurement/replenishment' | '/procurement/internal-transfers' {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return pathname.startsWith('/procurement/internal-transfers')
    ? '/procurement/internal-transfers'
    : '/procurement/replenishment';
}
